var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showingTooltip)?_c('div',{staticClass:"u-tooltip",style:({top: _vm.clientY + 'px', left: _vm.clientX + 'px'})},[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }